import Component from '../core/Component'
import Flickity from 'flickity'
import debounce from 'lodash/debounce'
import { queryAll } from '../utils/dom'

const defaults = {
    cellSelector: '[data-ref="item"]',
    prevNextButtons: false,
    wrapAround: true,
    pageDots: false,
    resize: true,
    groupCells: true,
    contain: true,
    autoplay: false,
    freeScroll: true
}

const STATES = {
    HIDDEN: 'is-hidden'
}

export default class StripesGallery extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            groups: []
        }
        this.carousels = []
        this.current = null
        this.handleDebouncedResize = debounce(this.handleResize,200)
    }

    prepare() {
        this.ref.groups.forEach(group => {
            const items = queryAll('[data-ref="item"]', group)
            const MIN_ITEMCOUNT = 15
            if (items.length < MIN_ITEMCOUNT) {
                const CLONING_REPEATS = Math.ceil(MIN_ITEMCOUNT/items.length - 1)
                for (let index = 0; index < CLONING_REPEATS; index++) {
                    items.forEach(item => group.appendChild(item.cloneNode(true)))
                }
            }
        })
        this.element.offsetHeight

        this.carousels = this.ref.groups
            .map(element => new Flickity(element, defaults))

        this.carousels.forEach(carousel => {
            carousel.on('pointerDown', () => this.handlePointerDown(carousel))
            carousel.on('scroll', progress => this.handleProgress(carousel, progress))
            carousel._startOffset = carousel.x
        })

        window.addEventListener('resize', this.handleDebouncedResize)
    }

    destroy() {
        this.carousels.forEach(carousel => carousel.destroy())
        window.removeEventListener('resize', this.handleDebouncedResize)
    }

    handleResize = () => {
        this.resize()
    }

    handlePointerDown(carousel) {
        this.current = carousel
    }

    handleProgress = (trigger, progress) => {
        if (trigger !== this.current) {
            return
        }
        this.carousels.forEach(carousel => {
            if (carousel !== this.current) {
                carousel.x = carousel._startOffset - progress * carousel.slidesWidth
                carousel.positionSlider()
            }
        })
    }

    hide() {
        this.element.classList.add(STATES.HIDDEN)
    }

    show() {
        this.element.classList.remove(STATES.HIDDEN)
        this.resize()
    }

    resize() {
        this.carousels.forEach(carousel => carousel.resize())
    }
}



// WEBPACK FOOTER //
// ./components/StripesGallery.js